import React, { useState } from 'react';
import { apis, hooks, models } from "@vote4dance/judging-sdk";
import { HeaderContainer, BodyContainer } from "../../../../base-react/components/Container";
import { App, Typography, Button, notification, Space } from 'antd';
import { useParams } from "react-router-dom";
import { _T } from "../../../../base-react/src/Localization";
import { PlusOutlined } from "@ant-design/icons";
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var FloorSource = models.floors.FloorSource;
import { FloorCard } from './components/FloorCard';
import { Loading } from '../../../../base-react/components/Loading';
import { useCompetition } from '../../../../base-react/hooks/Competition';
const { Title } = Typography;
export const Floor = () => {
    let { event_id } = useParams();
    const [, , , , , canEdit] = useCompetition(event_id);
    const { modal } = App.useApp();
    const [isLoading, setIsLoading] = useState(false);
    const floorSource = FloorSource(event_id);
    const [items, loadingItems, errorItems] = Stream(floorSource);
    const mainFloors = items ? items.filter((floor) => floor.floor_parent_id == null) : [];
    const onAddItem = async (item) => {
        setIsLoading(true);
        await Api.create(floorSource.url, item ? item : { floor_name: _T('floor.main'), floor_code: null })
            .catch((err) => {
            notification.error({
                message: err.message
            });
        });
        setIsLoading(false);
    };
    const onEditItem = async (item) => {
        setIsLoading(true);
        await Api.update(`${floorSource.url}/${item.floor_id}`, item)
            .catch((err) => {
            notification.error({
                message: err.message
            });
        });
        setIsLoading(false);
    };
    const onDeleteItem = (item) => {
        modal.confirm({
            title: _T('common.delete.title', { name: _T('floor.title').toLowerCase() }),
            content: _T('common.delete.content', { name: decodeURIComponent(item.floor_name) }),
            onOk() {
                setIsLoading(true);
                Api.destroy(`${floorSource.url}/${item.floor_id}`)
                    .then(() => {
                    setIsLoading(false);
                })
                    .catch((err) => {
                    setIsLoading(false);
                    notification.error({
                        message: err.message
                    });
                });
            }
        });
    };
    const getChildFloor = (parent) => (items ? items.filter((floor) => floor.floor_parent_id == parent.floor_id) : []);
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderContainer, null,
            React.createElement(Typography, null,
                React.createElement(Title, null, _T('floor.title')))),
        React.createElement(BodyContainer, null, loadingItems ? React.createElement(Loading, null) :
            React.createElement(Space, { orientation: 'vertical' },
                mainFloors.map((item) => React.createElement(FloorCard, { key: item.floor_id, item: item, onAddItem: onAddItem, onEditItem: onEditItem, onDeleteItem: onDeleteItem, childFloors: getChildFloor(item), disabled: !canEdit })),
                React.createElement(Button, { size: 'large', type: 'primary', loading: isLoading, onClick: () => onAddItem(), icon: React.createElement(PlusOutlined, null), disabled: !canEdit }, _T('common.create', { name: _T('floor.title').toLocaleLowerCase() }))))));
};
